import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import i18n from '@/infrastructure/i18n';
import { usePreferences } from '@/store/preferences';
export function I18nProvider({ children }) {
    const language = usePreferences((s) => s.language);
    const [ready, setReady] = useState(i18n.isInitialized);
    useEffect(() => {
        if (i18n.isInitialized)
            return;
        const onInit = () => setReady(true);
        i18n.on('initialized', onInit);
        return () => { i18n.off('initialized', onInit); };
    }, []);
    // If the user has made an explicit choice, honor it; otherwise leave the
    // browser-detected language in place.
    useEffect(() => {
        if (language && i18n.language !== language) {
            void i18n.changeLanguage(language);
        }
    }, [language]);
    // Keep <html lang="…"> in sync for accessibility (WCAG 3.1.1).
    useEffect(() => {
        const sync = () => { document.documentElement.lang = i18n.language || 'pt-BR'; };
        sync();
        i18n.on('languageChanged', sync);
        return () => { i18n.off('languageChanged', sync); };
    }, []);
    if (!ready)
        return null;
    return _jsx(_Fragment, { children: children });
}
